import { API_ROOT } from '../../config/config'
import { doGet, doPost, doDownload } from './utils'

// const API_ROOT = 'http://localhost:9003/api'

export const getProjectPaymentReview = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/request/list`
  return doPost(url, request)
}

export const getProjectPaymentReviewByStatus = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/request/filter`
  return doPost(url, request)
}

export const getProjectPaymentReviewById = (projectVersionId, projectPaymentReviewId, status) => {
  const url = `${API_ROOT}/review/reviewer/payment/request/${projectVersionId}/${projectPaymentReviewId}/${status}`
  return doGet(url)
}

export const getProjectPaymentReviewApprove = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/approve/list`
  return doPost(url, request)
}

export const getProjectPaymentReviewApproveByStatus = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/approve/filter`
  return doPost(url, request)
}

export const getProjectPaymentReviewApproveById = (projectPaymentReviewId) => {
  const url = `${API_ROOT}/review/reviewer/payment/approve/${projectPaymentReviewId}`
  return doGet(url)
}

export const sendRequestApprovePaymentReview = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/request`
  return doPost(url, request)
}

export const approvePaymentReview = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/approve`
  return doPost(url, request)
}

export const downloadPayment = (projectVersionId) => {
  const url = `${API_ROOT}/review/reviewer/payment/${projectVersionId}/download`
  return doDownload(url)
}

export const searchByReviewer = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/request/byreviewer/search`
  return doPost(url, request)
}

export const getDetailByReviewer = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/request/byreviewer/detail`
  return doPost(url, request)
}

export const sendRequestApproveByReviewer = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/request/byreviewer/submit`
  return doPost(url, request)
}

export const downloadPaymentByReviewer = (projectPaymentReviewGroupId) => {
  const url = `${API_ROOT}/review/reviewer/payment/byreviewer/${projectPaymentReviewGroupId}/download`
  return doDownload(url)
}

export const searchByReviewerForApprover = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/approve/byreviewer/search`
  return doPost(url, request)
}

export const getDetailByReviewerForApprover = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/approve/byreviewer/detail`
  return doPost(url, request)
}

export const approveByReviewerForApprover = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/approve/byreviewer/submit`
  return doPost(url, request)
}

/*----------------------------------------new api----------------------------------------------*/

//E-FORM เบิกจ่ายค่าตอบแทนการทบทวนโครงการ - นักวิชาการ
export const saveRequestMultipleProject = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/requestor/projects/save`
  return doPost(url, request)
}

export const saveRequestMultipleReviewer = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/requestor/reviewer/save`
  return doPost(url, request)
}

export const getReviewerPaymentInitialPage = (projectVersionId, projectPaymentReviewId, status) => {
  const url = `${API_ROOT}/review/reviewer/payment/requestor/page/initial/${status}?projectVersionId=${
    projectVersionId || ''
  }&projectPaymentReviewId=${projectPaymentReviewId || ''}`
  return doGet(url)
}

export const searchReviewerPayment = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/requestor/page/list`
  return doPost(url, request)
}

export const searchReviewerPaymentWithStatus = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/requestor/page/filter`
  return doPost(url, request)
}

//E-FORM เบิกจ่ายค่าตอบแทนการทบทวนโครงการ - ผู้มีอำนาจอนุมัติ
export const saveReviewerPaymentApprover = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/approver/approve`
  return doPost(url, request)
}

export const searchReviewerPaymentByReviewer = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/approver/page/reviewer/search`
  return doPost(url, request)
}

export const getReviewerPaymentInitialPageApprover = (
  projectVersionId,
  projectPaymentReviewId,
  status
) => {
  const url = `${API_ROOT}/review/reviewer/payment/approver/page/initial/${status}?projectVersionId=${
    projectVersionId || ''
  }&projectPaymentReviewId=${projectPaymentReviewId || ''}`
  return doGet(url)
}

export const searchReviewerPaymentApprover = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/approver/page/list`
  return doPost(url, request)
}

export const searchReviewerPaymentWithStatusApprover = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/approver/page/filter`
  return doPost(url, request)
}

export const getReviewerPaymentDetailByReviewer = (request) => {
  const url = `${API_ROOT}/review/reviewer/payment/approver/page/reviewer/detail`
  return doPost(url, request)
}

//E-FORM เบิกจ่ายค่าตอบแทนการทบทวนโครงการ - ดาว์นโหลดเอกสาร

export const downloadPaymentEForm = (projectReviewerPaymentId) => {
  const url = `${API_ROOT}/review/reviewer/payment/${projectReviewerPaymentId}/download`
  return doDownload(url)
}
